// import React, { useContext } from 'react';
// import { UserProfileContext } from '../../../context/userProfileContext';
// import { successNotifier } from '../../../components/NotificationHandler';
// import { Box, Flex, HStack, Stack, Text } from '@chakra-ui/react';
// import { BsWhatsapp } from 'react-icons/bs';
// import { FiLink } from 'react-icons/fi';

// function ShareInviteLink({ guestCode, onClose }) {
//   const { userProfile } = useContext(UserProfileContext);
//   console.log('userProfile  shahre', userProfile);

//   const inviteMessage = `${userProfile.tenantName} is inviting you to Abraham Adesanya estate. Please use ${guestCode} at the access point to gain access. reach me on ${userProfile.tenantPhone}`;

//   const copyToClippBoard = () => {
//     navigator.clipboard.writeText(inviteMessage).then(() => {
//       successNotifier('Link copied successfully');
//       onClose();
//     });
//   };

//   const handleShareViaWhatsapp = () => {
//     window
//       .open(`whatsapp://send?text=${inviteMessage}`, '_blank')
//       .then(onClose);
//   };

//   return (
//     <Stack textAlign='center'>
//       <Text fontSize='1.5rem' fontWeight='bold'>
//         Share Guest Access Code:
//       </Text>
//       <HStack gap='2rem' justify='space-between'>
//         <Box>
//           <Text pb='2'>share Access code via whatsapp</Text>
//           <Flex justify='center'>
//             <BsWhatsapp
//               size={30}
//               cursor='pointer'
//               //   onClick={() =>
//               //     window.open(`whatsapp://send?text=${inviteMessage}`, '_blank')
//               //   }
//               onClick={handleShareViaWhatsapp}
//             />
//           </Flex>
//         </Box>
//         <Box>
//           <Text pb='2'>Copy access code to clipboard</Text>
//           <Flex justify='center'>
//             <FiLink size={30} cursor='pointer' onClick={copyToClippBoard} />
//           </Flex>
//         </Box>
//       </HStack>
//     </Stack>
//   );
// }

// export default ShareInviteLink;

import React, { useContext } from 'react';
import { UserProfileContext } from '../../../context/userProfileContext';
import { successNotifier } from '../../../components/NotificationHandler';
import { Box, Flex, HStack, Stack, Text } from '@chakra-ui/react';
import { BsWhatsapp, BsClipboardData } from 'react-icons/bs';
// import { FiLink } from 'react-icons/fi';
import { timeout } from '../../../components/utils/timeout';
import { useNavigate } from 'react-router-dom';

function ShareInviteLink({ guestCode, onClose }) {
  const navigate = useNavigate();
  const { userProfile } = useContext(UserProfileContext);

  const inviteMessage = `${userProfile.tenantName} is inviting you to Abraham Adesanya Housing estate. Please use ${guestCode} at the access point to gain access. reach me on ${userProfile.tenantPhone}`;

  const copyToClippBoard = () => {
    navigator.clipboard.writeText(inviteMessage).then(() => {
      successNotifier('Link copied successfully');
      onClose();
      timeout(() => navigate('/my-estate'), 2500);
    });
  };

  const handleShareViaWhatsapp = () => {
    window
      .open(`whatsapp://send?text=${inviteMessage}`, '_blank')
      .then(onClose);
  };

  return (
    <Stack textAlign='center'>
      <Text fontSize='1.2rem' fontWeight='bold'>
        Share Guest Access Code:
      </Text>
      <HStack gap='2rem' justify='space-between'>
        <Box flex='1'>
          <Text pb='2'> Share Via whatsapp</Text>
          <Flex justify='center' color='teal.400'>
            <BsWhatsapp
              size={30}
              cursor='pointer'
              onClick={handleShareViaWhatsapp}
            />
          </Flex>
        </Box>
        <Box flex='1'>
          <Text pb='2'>Copy code to clipboard</Text>
          <Flex justify='center'>
            <BsClipboardData
              size={30}
              cursor='pointer'
              onClick={copyToClippBoard}
            />
          </Flex>
        </Box>
      </HStack>
    </Stack>
  );
}

export default ShareInviteLink;
